<template>
    <div class="products" v-if="slides.length">
        <div id="carouselIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div :class="['carousel-item', { active: i == 0 }]" v-for="(slide, i) in slides" :key="i">
                    <img :src="isMobile ? slide.mobile_image_url : slide.image_url" class="d-block" :alt="`Slider_${i}`" />

                    <div class="carousel-caption d-flex flex-column align-items-center align-items-md-start justify-content-center">
                        <div class="carousel-caption-title text-md-start mb-5" v-html="slide.text"></div>

                        <router-link :to="{ path: '/dc-power-distribution', query: { view: 'all' }}">
                            <b-button variant="primary" class="btn-trimm-wide" pill>{{ $t('ourProducts') }}</b-button>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- one set for all slides: Bootstrap moves "active" and aria-current itself -->
            <div class="carousel-indicators" v-if="slides.length > 1">
                <button v-for="(slide, i) in slides"
                        :key="i"
                        type="button"
                        data-bs-target="#carouselIndicators"
                        :data-bs-slide-to="i"
                        :class="['carousel-indicators-btn', { active: i == 0 }]"
                        :aria-current="i == 0 ? 'true' : null"
                        :aria-label="`Slide ${i + 1}`"></button>
            </div>
        </div>
    </div>
</template>

<script>
    import { MediaPointConstant } from '@/constants/mediaPoint-constants';
    import { Carousel } from 'bootstrap';

    export default {
        name: "products",

        props: {
            //visible slides from the API: [{ image_url, mobile_image_url, text }]
            slides: {
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                isMobile: false
            };
        },

        mounted() {
            //updated on resize and device switch, so the slide image follows the current width
            this.mobileQuery = window.matchMedia(`(max-width: ${MediaPointConstant.MediaPointMd}px)`);
            this.isMobile = this.mobileQuery.matches;
            this.mobileQuery.addEventListener('change', this.onMobileQueryChange);

            //Fixed an issue when carousel didn`t work if we change the route and return back to home page
            let indicator = document.getElementById("carouselIndicators");

            //all slides are hidden in admin - nothing to start
            if (!indicator)
                return;

            this.carousel = new Carousel(indicator, {
                interval: 5000,
                wrap: true
            });
        },

        //otherwise the carousel keeps cycling the removed element after leaving the page
        beforeUnmount() {
            this.mobileQuery.removeEventListener('change', this.onMobileQueryChange);
            this.carousel?.dispose();
        },

        methods: {
            onMobileQueryChange(e) {
                this.isMobile = e.matches;
            }
        }
    };
</script>
